import React, {useState} from 'react'
import PropTypes from 'prop-types'

const Select = ({name, children, id, className, label, placeholder, isRequired, isDisabled,}) => {
  const [placeholderShown, setPlaceholderShown] = useState(placeholder)

  return (
    <div className={`form-item ${className}`}>
      <select
        disabled={isDisabled}
        className={placeholderShown && 'has-placeholder'}
        name={name}
        required={isRequired}
        onChange={() => setPlaceholderShown(false)}
        id={id}>
        {placeholder && (
          <option hidden
            value="placeholder"
            selected>
            {/* Utiliza un placeholder generado con la etiqueta label para evitar escribir siempre el contenido */}
            {/* La validación de female es para el sustantivo femenino*/}
            {(typeof(placeholder) === 'boolean' || placeholder === 'female')
              ? `Elige ${placeholder === 'female' ? 'una' : 'un'} ${label.split(' ')[0].toLowerCase()}`
              // Si no se quiere un placeholder genérico, entonces se escribe a mano
              : placeholder
            }
          </option>
        )}
        {children}
      </select>
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

Select.defaultProps = {
  isRequired: false,
  isDisabled: false,
  placeholder: '',
  id: '',
  label: '',
  className: '',
}

export default Select

